var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 28,
    fill: "#FFEBC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26121_35487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26121_35487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7405 16.4507L31.3658 65.6831C30.982 66.4262 30.3894 66.8561 29.5881 66.9728C28.7867 67.0896 28.1236 66.8303 27.5988 66.1949L0.537573 33.4334C0.0127496 32.7981 -0.127792 32.0845 0.115949 31.2926C0.35969 30.5008 0.870272 29.9716 1.6477 29.7051L52.9852 13.115C53.9443 12.827 54.7519 13.08 55.4079 13.8743C56.064 14.6685 56.1748 15.5273 55.7405 16.4507ZM28.7208 60.3071L49.1373 19.3258L6.23536 33.0853L28.7208 60.3071Z",
    fill: "#395966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3856 52.6375L12.8269 41.0653L34.7799 31.3099L22.3856 52.6375Z",
    fill: "#FCBE1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.db9d7a9e64c14885d8baa472ba8481e6.svg";
export { ForwardRef as ReactComponent };